var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg32ArrowTurnFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-10 -10 136 136",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 8,
    strokeLinecap: "butt",
    d: "m0 102.96063l0 -57.915356l0 0c0 -24.87782 20.167458 -45.045277 45.045277 -45.045277l0 0l0 0c11.946751 0 23.404194 4.7458277 31.851818 13.193456c8.447632 8.447627 13.193459 19.905071 13.193459 31.851822l0 6.4350395l12.870079 0l-25.740158 25.740158l-25.740158 -25.740158l12.870079 0l0 -6.4350395c0 -10.661922 -8.643196 -19.305119 -19.305119 -19.305119l0 0l0 0c-10.661922 0 -19.305119 8.643196 -19.305119 19.305119l0 57.915356z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg32ArrowTurnFull);
export default __webpack_public_path__ + "static/media/32-arrow-turn-full.d60ba7867efcbf4b9e5aee40fd9287b8.svg";
export { ForwardRef as ReactComponent };